var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tradeoffer-container",
      class: [
        { tradeofferbox_show: _vm.tradeOfferBox.show && _vm.user.nickname },
      ],
    },
    [
      _c("div", { staticClass: "tradeofferbox" }, [
        !_vm.tradeOfferBox.list.length
          ? _c("div", { staticClass: "tradeoff_list" }, [
              _c("div", { staticClass: "noneitem-desc" }, [
                _vm._v("暂时没有进行中的报价"),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "tradeoff_list" },
              _vm._l(_vm.tradeOfferBox.list, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "traderoffer_listitem" },
                  [
                    _c("div", { class: ["titlebox", "state-" + item.state] }, [
                      _c("div", { staticClass: "state-text" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.statusdesc) +
                            _vm._s(
                              item.state == 0 && item.delivery == 1
                                ? "(人工发货)"
                                : ""
                            ) +
                            _vm._s(
                              item.state <= 1 ? "(" + item.time + ")" : ""
                            ) +
                            " "
                        ),
                      ]),
                      item.state > 1
                        ? _c(
                            "div",
                            {
                              staticClass: "btn-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteRow(index)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "ivu-icon ivu-icon-md-close",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "content-container" }, [
                      _c("div", { staticClass: "content-box" }, [
                        _c("div", { staticClass: "info-box" }, [
                          _c("div", { staticClass: "avatar-box" }, [
                            _c("div", { staticClass: "avatar" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("imgfilter")(item.itempic),
                                },
                              }),
                            ]),
                          ]),
                          _c("div", { staticClass: "senderinfo-box" }, [
                            _c("h5", { staticClass: "sender-name" }, [
                              _vm._v(_vm._s(item.itemname)),
                            ]),
                            _c("div", { staticClass: "join-time" }, [
                              _vm._v(
                                "订单发起时间: " + _vm._s(item.createTime)
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "ctrl-box" }, [
                          item.state == 1
                            ? _c(
                                "a",
                                {
                                  staticClass: "submit-button-small",
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      "https://steamcommunity.com/tradeoffer/" +
                                      item.tradeofferid,
                                  },
                                },
                                [_vm._v("前往处理")]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
        _c("div", { staticClass: "option" }, [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.switch_tradeofferbox_show(false)
                },
              },
            },
            [_vm._v("全部隐藏")]
          ),
          _c("div", { on: { click: _vm.RequestTradeOffer } }, [
            _c("i", { staticClass: "ivu-icon ivu-icon-md-refresh" }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }